import { appData } from '@/mocks/homepage';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-smartphone-line text-sm"></i>
              </div>
              {appData.subtitle}
            </div>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-4">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              {appData.desc}
            </p>
            <div className="flex flex-wrap gap-3 justify-center lg:justify-start mb-8">
              {appData.features.map((feat) => (
                <span
                  key={feat}
                  className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-100 border border-background-200/60 text-sm text-foreground-700 whitespace-nowrap"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-accent-600 text-xs"></i>
                  </div>
                  {feat}
                </span>
              ))}
            </div>

            <a
              href="#hero"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-colors"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
              立即体验移动观影
            </a>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="w-64 md:w-72">
              <div className="aspect-[3/4] rounded-2xl overflow-hidden ring-4 ring-background-200">
                <img
                  src={appData.image}
                  alt="玫瑰视频移动端观影"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}